(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gewaehrleistungs-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('warranty-label')) {
    customElements.define(
      'warranty-label',
      class WarrantyLabel extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.warranty-label__trigger');
          this.dialog = this.querySelector('.warranty-label__dialog');
          this.closeButton = this.querySelector('.warranty-label__close');

          this.trigger.addEventListener('click', () => this.dialog.showModal());
          this.closeButton.addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => this.trigger.focus());
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
